import React, { useEffect, useState, useContext } from "react";
import Link from "next/link";
import { Container, Box, Typography, Grid } from "@mui/material";
import { MapPin, Phone, Mail } from "react-feather";

import { GlobalContext } from "context";
import { getPageAllList } from "context/actions/pages";
import { useTranslation } from "react-i18next";
import CustomSnackBar from "components/CustomSnackBar";

let successTimeout = null;

const Footer = () => {
  const { state, dispatch } = useContext(GlobalContext);

  const [menus, setMenus] = useState([]);
  const [snack, setSnack] = useState({
    isOpen: false,
    msg: "",
    type: "success",
  });

  const { t } = useTranslation();

  useEffect(() => {
    getMenus();
  }, []);

  const getMenus = async () => {
    const datas = await getPageAllList("?isHeader=0");
    if (datas.status === "success") setMenus(datas.data);
  };

  const handleCloseSnack = () => {
    setSnack({ ...snack, isOpen: false });
  };

  return (
    <>
      {/* Top Footer Section */}
      <Container maxWidth={false} disableGutters className="bg-[#b07f50] py-6">
        <Container maxWidth="lg">
          <Grid
            container
            spacing={4}
            justifyContent="center"
            alignItems="flex-start"
            textAlign="center"
          >
            {/* Brand + Info Links */}
            <Grid item lg={4} md={4} sm={12} xs={12}>
              <Box
                sx={{
                  fontFamily: "Philosopher",
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: 25,
                  mb: 2,
                }}
              >
                Ezen Travel
              </Box>
              {menus
                .filter(
                  (item) =>
                    item.name === "Бидний тухай" ||
                    item.name === "Мэдээлэл" ||
                    item.name === "Холбоо барих"
                )
                .map((m, ind) => (
                  <Box key={ind} mb={1}>
                    <Link
                      href={m.url ? "/" + m.url : "/content/" + m.id}
                      passHref
                    >
                      <Typography
                        variant="body2"
                        className="text-white font-bold cursor-pointer hover:underline"
                      >
                        {m.name}
                      </Typography>
                    </Link>
                  </Box>
                ))}
            </Grid>

            {/* Tours Section */}
            <Grid item lg={4} md={4} sm={12} xs={12}>
              <Box
                sx={{
                  fontFamily: "Philosopher",
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: 25,
                  mb: 2,
                }}
              >
                Аяллууд
              </Box>
              {menus
                .filter(
                  (item) =>
                    item.name === "Гадаад аялал" || item.name === "Дотоод аялал"
                )
                .map((m, ind) => (
                  <Box key={ind} mb={1}>
                    <Link
                      href={m.url ? "/" + m.url : "/content/" + m.id}
                      passHref
                    >
                      <Typography
                        variant="body2"
                        className="text-white font-bold cursor-pointer hover:underline"
                      >
                        {m.name}
                      </Typography>
                    </Link>
                  </Box>
                ))}
            </Grid>

            {/* Contact Section */}
            <Grid item lg={4} md={4} sm={12} xs={12}>
              <Box
                sx={{
                  fontFamily: "Philosopher",
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: 25,
                  mb: 2,
                }}
              >
                Холбоо барих
              </Box>
              <Box className="flex items-center justify-center ml-4 mb-2">
                <Mail color="#fff" size={18} />{" "}
                <Typography
                  variant="body2"
                  className="text-white !ml-2 !mt-[1px] font-bold text-left"
                >
                  info@ezentravel.mn
                </Typography>
              </Box>
              <Box className="flex !ml-[-4px] items-center justify-center ">
                <Phone color="#fff" size={18} />
                <Typography
                  variant="body2"
                  className="text-white !ml-2 !mt-[4px] font-bold text-left"
                >
                  (+976) 99020368
                </Typography>
              </Box>
              <Box className="flex items-start justify-center ml-1 !mt-[10px] mb-2">
                <MapPin color="#fff" size={18} />
                <Typography
                  variant="body2"
                  className="text-white !ml-2 font-bold text-left"
                >
                  Монгол улс, <br /> Улаанбаатар хот, <br /> Баянзүрх дүүрэг,{" "}
                  <br />
                  26-р хороо, <br />
                  Эдү кампус, 208
                </Typography>{" "}
              </Box>{" "}
            </Grid>
          </Grid>
        </Container>
      </Container>

      {/* Bottom Bar */}
      <Container
        maxWidth={false}
        disableGutters
        className="flex justify-center items-center border-t border-[#D4AF37] bg-[#cba47e] py-4"
      >
        <Link
          href="https://alphafox.mn"
          underline="none"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            textDecoration: "none",
            "&:hover img": { transform: "scale(1.05)" },
          }}
        >
          {/* ✅ Logo/Icon */}
          <Box className="flex items-center cursor-pointer">
            <Typography variant="body2" className="text-white text-center">
              © 2025 Ezen Travel - All rights reserved. Developed by Alpha Fox
            </Typography>
            <Box
              component="img"
              src="https://alphafox.mn/developedLogo.png" // 👈 Replace with your icon path
              alt="AlphaFox"
              sx={{
                width: 22,
                height: 22,
                ml: 1,
              }}
            />
          </Box>
        </Link>
      </Container>

      {/* SnackBar */}
      <CustomSnackBar
        open={snack.isOpen}
        msg={snack.msg}
        handleClose={handleCloseSnack}
        type={snack.type}
      />
    </>
  );
};

export default Footer;
